import { GridItem } from '@chakra-ui/react';
import React from 'react';
import { getYearsView, viewAmount, viewPercentage } from 'utils/number';

const TransactionDetailsCard = ({ data }) => {
    return (
        <GridItem>
            <div className='preview-box'>
                <div className="preview-heading">
                    <p>Transaction Details</p>
                </div>
                <div className='preview-body' >
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    Transaction ID
                                </td>
                                <td>
                                    { data.applicationId || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Transaction Name
                                </td>
                                <td>
                                    { data.applicationName || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Loan Purpose
                                </td>

                                <td>
                                    { data.loanPurpose || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Purchase Price/Estimated Value
                                </td>

                                <td>
                                    { viewAmount(data.purchasePriceValue) }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Loan Amount
                                </td>

                                <td>
                                    { viewAmount(data.loanAmount) }
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Proposed Interest Rate
                                </td>

                                <td>
                                    6.000%
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Number of Years
                                </td>

                                <td>
                                    { getYearsView(data.noOfYears) || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    CLTV
                                </td>

                                <td>
                                    { viewPercentage(data.metaData.CLTV) || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    LTV
                                </td>

                                <td>
                                    { viewPercentage(data.metaData.LTV) || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    APR
                                </td>

                                <td>
                                    { viewPercentage(data.metaData.APR) || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Mid Credit Score
                                </td>

                                <td>
                                    { data.metaData.creditScore || 'N/A'}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    First Time Home Buyer
                                </td>

                                <td>
                                    { data.metaData.firstTimeLoanBuyer ? 'Yes' : 'No'}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </GridItem>
    );
};

export default TransactionDetailsCard;
